import type {
	DashboardListVariable,
	DashboardVariable,
	DashboardVariableSpec,
} from "../../../../common/dashboard-spec";

export type DashboardListVariableSpec = Extract<DashboardVariableSpec, { kind: "ListVariable" }>;

export type DynamicListVariable = DashboardVariable & {
	readonly spec: DashboardListVariableSpec & {
		readonly spec: DashboardListVariable & {
			readonly plugin: Exclude<DashboardListVariable["plugin"], { kind: "StaticList" }>;
		};
	};
};

export function isDynamicListVariable(variable: DashboardVariable): variable is DynamicListVariable {
	return (
		variable.spec.kind === "ListVariable" &&
		variable.spec.spec.plugin.kind !== "StaticList" &&
		(variable.spec.spec.plugin.kind === "MetricLabelNames" ||
			variable.spec.spec.plugin.kind === "MetricLabelValues" ||
			variable.spec.spec.plugin.kind === "MetricPromQL")
	);
}
